// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_d7-b";
export var colorBlue = "_d7-8";
export var colorDot = "_d7-0";
export var colorDotLarge = "_d7-2";
export var colorDotSmall = "_d7-1";
export var colorGreen = "_d7-7";
export var colorGrey = "_d7-3";
export var colorOrange = "_d7-5";
export var colorPink = "_d7-a";
export var colorPurple = "_d7-9";
export var colorRed = "_d7-4";
export var colorYellow = "_d7-6";